import { createContext, useContext, useState } from 'react'
import type { ReactNode } from 'react'

interface AccountContextType {
  selectedAccountId: string | null
  setSelectedAccountId: (accountId: string | null) => void
}

const AccountContext = createContext<AccountContextType | undefined>(undefined)

export function AccountProvider({ children }: { children: ReactNode }) {
  // Initialize from localStorage or default to 'ALL'
  const [selectedAccountId, setSelectedAccountIdState] = useState<string | null>(() => {
    const stored = localStorage.getItem('fh_selected_account')
    return stored || 'ALL'
  })

  const setSelectedAccountId = (accountId: string | null) => {
    const value = accountId || 'ALL'
    setSelectedAccountIdState(value)
    localStorage.setItem('fh_selected_account', value)
  }

  return (
    <AccountContext.Provider value={{ selectedAccountId, setSelectedAccountId }}>
      {children}
    </AccountContext.Provider>
  )
}

export function useAccount() {
  const context = useContext(AccountContext)
  if (context === undefined) {
    throw new Error('useAccount must be used within an AccountProvider')
  }
  return context
}
